import React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  status?: 'Active' | 'Scheduled' | 'Draft' | 'Ready' | 'Rendering' | string;
  variant?: 'primary' | 'secondary' | 'outline';
}

export function Badge({ status, variant, className = '', children, ...props }: BadgeProps) {
  const content = children || status;

  let styles =
    'aspectly:px-3 aspectly:py-1 aspectly:rounded-full aspectly:text-[10px] aspectly:font-black aspectly:uppercase aspectly:tracking-wider aspectly:inline-flex aspectly:items-center aspectly:justify-center';

  // Specific status overrides
  if (status) {
    switch (status) {
      case 'Active':
        styles += 'aspectly:bg-primary/10 aspectly:text-primary';
        break;
      case 'Scheduled':
        styles += 'aspectly:bg-tertiary/10 aspectly:text-tertiary';
        break;
      case 'Draft':
        styles += 'aspectly:bg-stone-100 aspectly:text-on-surface-variant';
        break;
      case 'Ready':
        styles += 'aspectly:bg-white aspectly:text-tertiary aspectly:border aspectly:border-outline-variant/30';
        break;
      case 'Rendering':
        styles += 'aspectly:bg-primary-container aspectly:text-primary aspectly:border aspectly:border-primary-fixed';
        break;
      default:
        styles += 'aspectly:bg-surface-container-high aspectly:text-on-surface';
    }
  } else if (variant) {
    if (variant === 'primary') styles += 'aspectly:bg-primary/10 aspectly:text-primary';
    if (variant === 'secondary') styles += 'aspectly:bg-secondary-container aspectly:text-on-secondary-container';
    if (variant === 'outline')
      styles += 'aspectly:bg-white aspectly:border aspectly:border-outline-variant/30 aspectly:text-on-surface-variant';
  }

  return (
    <span className={`${styles} ${className}`} {...props}>
      {content}
    </span>
  );
}
